import { onUnauthenticated } from "@nabble/sdk";
import { type MutableRefObject, useEffect } from "react";
import { isSignedIn, stateAfterSessionLost } from "./authStateTransitions";
import { markSessionExpired, rememberReturnTo } from "./returnTo";
import type { AuthStateStore } from "./useAuthState";

/** Reacts to any 401 from the apiClient: the session is gone. */
export function useSessionLoss(store: AuthStateStore, loggingOut: MutableRefObject<boolean>): void {
  const { commit, stateRef } = store;
  useEffect(
    () =>
      onUnauthenticated(() => {
        // A 401 while fully signed in means the session expired (idle or
        // absolute limit, or closed elsewhere): remember where the user was
        // and tell them on the login screen. A 401 during the login flow or
        // right after an explicit logout is expected and silent.
        if (isSignedIn(stateRef.current) && !loggingOut.current) {
          markSessionExpired();
          rememberReturnTo(`${window.location.pathname}${window.location.search}`);
        }
        commit(stateAfterSessionLost);
      }),
    [commit, stateRef, loggingOut],
  );
}
